import { render, staticRenderFns } from "./InputSerialNumber.vue?vue&type=template&id=3a67520f&scoped=true&"
import script from "./InputSerialNumber.vue?vue&type=script&lang=ts&"
export * from "./InputSerialNumber.vue?vue&type=script&lang=ts&"
import style0 from "./InputSerialNumber.vue?vue&type=style&index=0&id=3a67520f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67520f",
  null
  
)

export default component.exports